<template>
  <div class="auth-container">
    <div class="status">
      <div :class="['status-icon', isAuthenticated ? 'connected' : 'not-connected']">
        {{ isAuthenticated ? '✅' : '❌' }}
      </div>
      <div class="status-text">{{ authStatus }}</div>
    </div>
    <button v-if="!isAuthenticated" @click="login" class="google-btn">
      <span class="google-icon"></span>
      התחבר עם Google
    </button>
    <button v-else @click="logout" class="logout-btn">
      התנתק
    </button>
  </div>
</template>

<script>
import AuthService from '@/services/auth';
import ApiService from '@/services/api';

export default {
  name: 'GoogleAuth',
  data() {
    return {
      isAuthenticated: false
    };
  },
  computed: {
    authStatus() {
      return this.isAuthenticated ? 'מחובר לחשבון Google' : 'לא מחובר';
    }
  },
  created() {
    this.checkAuth();
  },
  methods: {
    checkAuth() {
      this.isAuthenticated = AuthService.isAuthenticated();
      this.$emit('auth-changed', this.isAuthenticated);
    },
    login() {
      window.location.href = ApiService.getAuthUrl();
    },
    logout() {
      AuthService.clearToken();
      this.isAuthenticated = false;
      this.$emit('auth-changed', false);
    }
  }
}
</script>

<style scoped>
.auth-container {
  text-align: center;
}

.status {
  margin-bottom: 20px;
  font-weight: 500;
}

.status-icon {
  font-size: 40px;
  margin-bottom: 10px;
}

.connected {
  color: var(--secondary-color);
}

.not-connected {
  color: var(--danger-color);
}

.google-btn, .logout-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 220px;
  margin: 20px auto;
  background-color: var(--primary-color);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.2s;
}

.google-btn:hover, .logout-btn:hover {
  background-color: #3367d6;
  transform: translateY(-2px);
}

.google-icon {
  width: 24px;
  height: 24px;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 488 512"><path fill="white" d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"/></svg>');
  background-repeat: no-repeat;
}

.logout-btn {
  background-color: var(--danger-color);
}

.logout-btn:hover {
  background-color: #d33828;
}
</style>